/**
 * email address and product type
 * pending registrations
 */
(function() {
	'use strict';

	angular
		.module('smb-app')
		.directive('smbRegister', [
			RegisterDirective
		])
		.controller('smbRegisterController', [
			'pxEnvironmentService',
			RegisterController
		]);

	var templateUrl = require('./register.template');
	function RegisterDirective() {
		return {
			restrict: 'E',
			controller: 'smbRegisterController',
			controllerAs: 'vm',
			templateUrl: templateUrl,
			bindToController: true,
			scope: {
				deploymentId: '@',
				authToken: '@'
			}
		};
	}

	function RegisterController(pxEnvironmentService) {
		var vm = this;
		vm.pxEnvironmentService = pxEnvironmentService;
		vm.agreeToTerms = false;
	}
}());


//////////////////
// WEBPACK FOOTER
// ./app/components/register/register.js
// module id = 94
// module chunks = 1